import { connect } from 'react-redux';
import { updateFavourite } from '@noths/polaris-client-user-favourites';
import type { Product } from '@noths/polaris-dev-ts-types';
import getConfig from 'next/config';

import { ProductList } from 'src/components/organisms/ProductList/components/ProductList';
import { productListClick } from 'src/components/organisms/ProductList/modules/actions';
import { selectReferredBy } from 'src/components/organisms/ProductList/modules/selectors';
import type {
  ProductListContainerDispatchProps,
  ProductListContainerStateProps,
} from 'src/components/organisms/ProductList/types';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProviderAttributionToken } from 'src/redux/products/selectors';
import { elevaateProductImpressions } from 'src/redux/products/thunks/elevaateProductImpressions';
import type { UpdateHistoryPayload } from 'src/redux/products/thunks/updatePageHistory';
import { updatePageHistory } from 'src/redux/products/thunks/updatePageHistory';
import type { AppThunkDispatch } from 'src/redux/store';
import { actions as visibilityTrackingActions } from 'src/redux/visibilityTracking';
import type { NextConfig } from 'src/types';

type ProductCode = Product['code'];

const nextConfig = getConfig() as NextConfig;

export const mapStateToProps = (state: ReduxApplicationState): ProductListContainerStateProps => {
  return {
    referredBy: selectReferredBy(state),
    providerAttributionToken: selectProviderAttributionToken(state),
  };
};

export const mapDispatchToProps = (
  dispatch: AppThunkDispatch,
): ProductListContainerDispatchProps => {
  return {
    updateFavourite: (productCode: ProductCode) =>
      dispatch(updateFavourite({ productCode, nextConfig })),
    updatePageHistory: (payload: UpdateHistoryPayload) => dispatch(updatePageHistory(payload)),
    onProductVisible: (productId: number) =>
      dispatch(visibilityTrackingActions.onProductVisible({ productId })),
    onProductClick: ({
      productUrl,
      destinationUrl,
      productCode,
      linkOpensInSameWindow,
    }: {
      productUrl: string;
      destinationUrl: string;
      productCode: ProductCode;
      linkOpensInSameWindow: boolean;
    }) => {
      dispatch(visibilityTrackingActions.sendProductImpressionBatch());
      dispatch(
        productListClick({ productUrl, destinationUrl, productCode, linkOpensInSameWindow }),
      );
    },
    elevaateProductImpressions: (products: Product[]) =>
      dispatch(elevaateProductImpressions({ products })),
  };
};

export const ProductListContainer = connect(mapStateToProps, mapDispatchToProps)(ProductList);
